import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from './../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  token:string | undefined = ''
  constructor(
    private http: HttpClient,
  ) {
    this.token = localStorage.getItem('token') || ''
  }


  getObject(url: string, params?: any): Promise<any> {
    return new Promise((resolve, reject) => {
      if (params) {

        return this.http.get(`${environment.API_URL}${url}`, { params: params })
          .subscribe((res: any) => {
              resolve({ response: res, msg: 'success' });
          }, (err): any => {
            reject({ msg: err.error.error });
          });
      } else {
        return this.http.get(`${environment.API_URL}${url}`)
        .subscribe((res: any) => {
          resolve({ response: res, msg: 'success' });
      }, (err): any => {
        reject({ msg: err.error.error });
      });
      }

    });
  }

  get(url: string, params?: any): Promise<any> {
    return new Promise((resolve, reject) => {
      if (params) {

        return this.http.get(`${environment.API_URL}${url}`, { params: params })
          .subscribe((res: any) => {
            if (res.state == 'success') {
              resolve({ response: (res.response?.data ? res.response.data : res.response), msg: 'success' });
            }
            else {
              reject({ msg: res.msg });
            }
          }, (err): any => {
            reject({ msg: err.error.error });
          });
      } else {
        return this.http.get(`${environment.API_URL}${url}`)
          .subscribe((res: any) => {
            if (res.state == 'success') {
              resolve({ response: (res.response.data ? res.response.data : res.response), msg: 'success' });
            }
            else {
              reject({ msg: res.msg });
            }
          }, (err): any => {
            reject({ msg: err.error.error });
          });
      }

    });
  }


  getPaginate(url: string, params?: any): Promise<any> {
    return new Promise((resolve, reject) => {
      if (params) {

        return this.http.post(`${url}`, {})
          .subscribe((res: any) => {
            if (res.state == 'success') {
              resolve({ response: res.response.data, msg: 'success' });
            }
            else {
              reject({ msg: res.msg });
            }
          }, (err): any => {
            reject({ msg: err.error.error });
          });
      } else {
        return this.http.post(`${url}`, {})
          .subscribe((res: any) => {
            if (res.state == 'success') {
              resolve({ response: (res.response.data ? res.response.data : res.response), msg: 'success' });
            }
            else {
              reject({ msg: res.msg });
            }
          }, (err): any => {
            reject({ msg: err.error.error });
          });
      }

    });
  }

  getFile(url: string): any {
    return this.http.get(`${url}`);
  }

  post(url: string, params?: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const body = params !== undefined ? params : {};
      return this.http.post(`${environment.API_URL}${url}`, body)
        .subscribe((response: any) => {
          if (response.state == 'success') {
            resolve({ data: response.data ? response.data : response.response.data, msg: 'success' });
          }
          else {
            reject({ msg: response.msg });
          }
        }, (err): any => {
          reject({ msg: err });
        });
    });
  }

  delete(url: string, params?: any): Promise<any> {
    return new Promise((resolve, reject) => {
      return this.http.delete(`${environment.API_URL}${url}`, {params})
        .subscribe((response: any) => {
          if (response.state == 'success') {
            resolve({ data: response.data ? response.data : response.response.data, msg: 'success' });
          }
          else {
            reject({ msg: response.msg });
          }
        }, (err): any => {
          reject({ msg: err });
        });
    });
  }

  postFile(url: string, params?: any, comprimir?:boolean): Promise<any> {
    return new Promise((resolve, reject) => {

      if(!this.token){
        this.token = localStorage.getItem('token') as string
      }
      let headers = new HttpHeaders()
      .append('Authorization', `Bearer ${this.token}`);
      return this.http.post(`${environment.API_URL}${url}`, params, {params: params, headers})
        .subscribe((response: any) => {
          if (response.state == 'success') {
            resolve({ data: response.response.data, msg: 'success' });
          }
          else {
            reject({ msg: response.msg });
          }
        }, (err): any => {
          reject({ msg: err.error.error });
        });
    });
  }



  post2(url: string, params?: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const body = params !== undefined ? params : {};
      return this.http.post(`${environment.API_URL}${url}`, body)
        .subscribe((response: any) => {
          if (response.state == 'success') {
            resolve({ data: response.response, msg: 'success' });
          }
          else {
            reject({ msg: response.msg });
          }
        }, (err): any => {
          reject({ msg: err.error.error });
        });
    });
  }

  post3(url: string, params?: any): any {
    const body = params !== undefined ? params : {};
    return this.http.post(`${environment.API_URL}${url}`, body);
  }

  put(url: string, params?: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const body = params !== undefined ? params : {};
      return this.http.put(`${environment.API_URL}${url}`, body)
        .subscribe((response: any) => {
          if (response.state == 'success') {
            resolve({ data: response.response.data, msg: 'success' });
          }
          else {
            reject({ msg: response.msg });
          }
        }, (err): any => {
          reject({ msg: err.error.error });
        });
    });
  }

  put2(url: string, params?: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const body = params !== undefined ? params : {};
      return this.http.put(`${environment.API_URL}${url}`, body)
        .subscribe((response: any) => {
          if (response.state == 'success') {
            resolve({ data: response.response, msg: 'success' });
          }
          else {
            reject({ msg: response.msg });
          }
        }, (err): any => {
          reject({ msg: err.error.error });
        });
    });
  }

  postWithoutToken(url: string, params?: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const body = params !== undefined ? params : {};
      return this.http.post(`${environment.API_URL}${url}`, body)
        .subscribe((response: any) => {
          if (response.state == 'success') {
            resolve({ data: response.data, msg: response.msg });
          }
          else {
            reject({ msg: response.msg });
          }
        }, (err): any => {
          reject({ msg: err.error.error });
        });
    });
  }

  loginPostWithoutToken(url: string, params?: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const body = params !== undefined ? params : {};
      return this.http.post(`${environment.API_URL}${url}`, body)
        .subscribe((response: any) => {
          if (response.state == 'success') {
            resolve({ access_token: response.access_token });
          }
          else {
            reject({ msg: response.msg });
          }
        }, (err): any => {
          reject({ msg: err.error.error });
        });
    });
  }
}
